import {
  getEmailMessageCompletedTableUpdate,
  hasEmailListPendingItem,
  isEmailMessageCompletedTableReload,
} from '../../Email.utils'

export function useEmailListMessageCompletedHandlers({
  handleUpdateItem,
  items,
  onReload,
}) {
  function handleMessageCompleted(payload) {
    const update = getEmailMessageCompletedTableUpdate(items, payload)

    if (isEmailMessageCompletedTableReload(update)) {
      onReload?.()

      return
    }

    if (update) {
      handleUpdateItem(update)
    }
  }

  function handleInitialSubscribe() {
    if (hasEmailListPendingItem(items)) {
      onReload?.()
    }
  }

  return { handleInitialSubscribe, handleMessageCompleted }
}
